export default "__VITE_ASSET__DUG8wblA__"